<template>
  <div>
    <ViewTemplate :table-props="mappingColumns" :project-param-id="projectParamId" :mapper-param-id="mapperParamId" />
  </div>
</template>

<script>
import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import TabContentView from "./TabContentView.vue";
import ViewTemplate from "@/components/ViewTemplate.vue";

export default {
  name: pageViews.FIELDMAPPINGVIEW,
  methods: {
    setValuesToStore(type) {
      Store.commit("setType", type);
    }
  },
  mounted() {
    this.setValuesToStore(type.MAPPER_MAPPING);
  },
  components: {
    TabContentView,
    ViewTemplate
  },
  data() {
    return {
      uploadConfigs: {
        action: "generator",
        actionLabel: "Generator",
        title: "Mapper Config Generator",
        type: type.MAPPER_MAPPING,
        accept: ".zip",
      },
      mappingColumns: {
        type: type.MAPPER_MAPPING,
        isMultiSelectionAllowed: true,
        defaultSortOrder: { name: "asc", label: "Ascending" },
        defaultSortColumn: { name: "Process", label: "Process" },
        configs: [
          { name: "usecaseLocation", label: "Use Case Location", order: 1, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "usecase", label: "Use Case", order: 2, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "processLocation", label: "Process Location", order: 3, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "process", label: "Process", order: 4, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "groupName", label: "Group Name", order: 5, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "activityName", label: "Activity Name", order: 6, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "inputNode", label: "Input Node", order: 7, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "bindingNode", label: "Binding Node", order: 8, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "condition", label: "Condition", order: 9, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "conditionGroup", label: "Condition Group", order: 10, isSortable: true, defaultSelected: true },
        ],
        actions: {
          viewPopup: { label: 'View Output' },
          download: { label: 'Request Download' },
          calculate: { label: 'Calculate Complexity' },
        },
      },
    };
  },
  props: ["projectParamId", "mapperParamId"],
};
</script>
